window.addEventListener('load', () => {
  const activateBlowserAlert = document.getElementsByClassName('user_identity-registration_form');

  if (activateBlowserAlert[0]) {
    if (activateBlowserAlert[0].dataset.userIdentityRegistration == "true") {
      // ref: https://developer.mozilla.org/ja/docs/Web/Events/beforeunloado
      window.addEventListener("beforeunload", showBlowserAlert, false);
    }
  }

  const signUpForm = document.getElementById('sign_up_form');
  if (signUpForm) {
    signUpForm.addEventListener('submit', () => {
      window.removeEventListener("beforeunload", showBlowserAlert, false);
    });
  }

  function showBlowserAlert(event) {
    event.preventDefault();
    event.returnValue = ""; // chrome対応
  }
});

import Rails from 'rails-ujs';
import Vue from 'vue/dist/vue.esm';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);
import {
  required,
  minLength,
  maxLength,
  email
} from 'vuelidate/lib/validators';
import { Core as YubinBangoCore } from 'yubinbango-core2';


window.addEventListener('load', () => {
  if ( !Rails.$('#user_identity_forms')[0] ) { return; }

  const PHONE_NUMBER_REGEX = /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/;

  new Vue({
    el: '#user_identity_forms',
    data() {
      return {
        name: Rails.$('#user_name')[0].value,
        last_name: Rails.$('#user_last_name')[0].value,
        first_name: Rails.$('#user_first_name')[0].value,
        email: Rails.$('#user_email')[0].value,
        password: '',
        tel: Rails.$('#user_tel')[0].value,
        sex: Rails.$('#sex-select-box')[0].value,
        job: Rails.$('#job-select-box')[0].value,
        birth_year: Rails.$('#user_birth_year')[0].value,
        birth_month: Rails.$('#user_birth_month')[0].value,
        birth_day: Rails.$('#user_birth_day')[0].value,
        postal_code: Rails.$('#user_postal_code')[0].value,
        prefecture_id: Rails.$('#user_prefecture_id')[0].value,
        city_address: Rails.$('#user_city_address')[0].value,
        street_address: Rails.$('#user_street_address')[0].value,
      };
    },
    validations() {
      if (Rails.$('#tel_required_label')[0]) {
        return {
          last_name: {
            required
          },
          first_name: {
            required
          },
          name: {
            required
          },
          email: {
            required,
            email
          },
          password: {
            required,
            minLength: minLength(6)
          },
          postal_code: {
            required,
            isMatch:(postal_code) => /^[0-9]{7}$/.test(postal_code)
          },
          tel: {
            required,
            minLength: minLength(6),
            maxLength: maxLength(13),
            isMatch:(tel) => PHONE_NUMBER_REGEX.test(tel)
          },
          sex: {
            required
          },
          job: {
            required
          },
          birth_year: {
            required
          },
          birth_month: {
            required
          },
          birth_day: {
            required
          },
          prefecture_id: {},
          city_address: {},
          street_address: {}
        };
      } else {
        return {
          last_name: {
            required
          },
          first_name: {
            required
          },
          name: {
            required
          },
          email: {
            required,
            email
          },
          password: {
            required,
            minLength: minLength(6)
          },
          postal_code: {
            required,
            isMatch:(postal_code) => /^[0-9]{7}$/.test(postal_code)
          },
          tel: {
            maxLength: maxLength(13)
          },
          sex: {
            required
          },
          job: {
            required
          },
          birth_year: {
            required
          },
          birth_month: {
            required
          },
          birth_day: {
            required
          },
          prefecture_id: {},
          city_address: {},
          street_address: {}
        };
      }
    },
    updated() {
      // vuelidateの影響で消えてしまうので、SNS連携で取得した値がもしあればここで設定する
      if (Rails.$('#sns_user_email')[0]) {
        if( this.email == '' && Rails.$('#sns_user_email')[0].value ){
          this.email = Rails.$('#sns_user_email')[0].value;
          this.$v.email.$touch();
          Rails.$('#sns_user_email')[0].value = null;
        }
      }
      if (Rails.$('#sns_user_name')[0]) {
        if( this.name == '' && Rails.$('#sns_user_name')[0].value ){
          this.name = Rails.$('#sns_user_name')[0].value;
          this.$v.name.$touch();
          Rails.$('#sns_user_name')[0].value = null;
        }
      }
      if (Rails.$('#sns_user_first_name')[0]) {
        if( this.first_name == '' && Rails.$('#sns_user_first_name')[0].value ){
          this.first_name = Rails.$('#sns_user_first_name')[0].value;
          this.$v.first_name.$touch();
          Rails.$('#sns_user_first_name')[0].value = null;
        }
      }
      if (Rails.$('#sns_user_last_name')[0]) {
        if( this.last_name == '' && Rails.$('#sns_user_last_name')[0].value ){
          this.last_name = Rails.$('#sns_user_last_name')[0].value;
          this.$v.last_name.$touch();
          Rails.$('#sns_user_last_name')[0].value = null;
        }
      }
      if (Rails.$('#sns_user_password')[0]) {
        if( this.password == '' && Rails.$('#sns_user_password')[0].value ){
          this.password = Rails.$('#sns_user_password')[0].value;
          this.$v.password.$touch();
          Rails.$('#sns_user_password')[0].value = null;
        }
      }
    },
    methods: {
      buttonClass(formInvalid) {
        if (formInvalid) {
          return 'bg_clr_btn_noactive';
        } else {
          return 'active';
        }
      },
      annotationLabelClass(formInvalid) {
        if (formInvalid) {
          return '';
        } else {
          return 'hidden';
        }
      },
      checkIconClass(fieldInvalid) {
        if (fieldInvalid) {
          return 'hidden';
        } else {
          return '';
        }
      },
      telCheckIconClass(fieldModel) {
        const showIcon = PHONE_NUMBER_REGEX.test(fieldModel);
        if (showIcon) {
          return;
        } else {
          return 'hidden';
        }
      }
    },
    watch: {
      postal_code(postal_code) {
        const _this = this;
        new YubinBangoCore(postal_code, (addr) => {
          _this.prefecture_id = addr.region;
          _this.city_address = addr.locality;
          _this.street_address = addr.street;
        });
      }
    }
  });
});
